const dummyTargetServiceMapping = {
  M2A: ["Amount", "Count"],
  "M2M SEND": ["Amount", "Count"],
  "MOBILE RECHARGE": ["Amount", "Count"],
  "PAY BILL": ["Amount", "Count"],
  PAYMENT: ["Amount", "Count", "MAU"],
};

const dummyData = [
  {
    campaign_name: "My Dummy Campaign 6",
    campaign_id: "SERV-REF-1748160058",
    campaign_duration: "Jun 01, 2025 to Jun 30, 2025",
    services_considered: "PAYMENT - Amount, Count",
    is_active: true,
    is_disbursed: false,
  },
  {
    campaign_name: "My Dummy Campaign 7",
    campaign_id: "SERV-REF-1748239315",
    campaign_duration: "Jun 01, 2025 to Jun 30, 2025",
    services_considered: "PAYMENT - Amount, Count",
    is_active: true,
    is_disbursed: false,
  },
];

export { dummyData, dummyTargetServiceMapping };
